import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import { CSSProperties } from 'react';

import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';


const classPrefix = 'filter-panel';

export const filteringListContainerHeight = 300;

export const filterComponentStyle: CSSProperties = {
  marginTop: TabStyles.Spacing.MediumSpace,
  width: '100%',
};

export const filterPanelContainer = cssClass(classPrefix, 'container', {
  display: 'block',
  marginLeft: TabStyles.Spacing.LargeSpace,
  marginRight: TabStyles.Spacing.LargeSpace,
  marginBottom: TabStyles.Spacing.ExtraLargeSpace,
  marginTop: '2px' // Room for the focus indicator
});

export const clearAllButton = cssClass(classPrefix, 'clear-all', {
  display: 'block',
  marginRight: 0,
  marginLeft: 'auto',
});

export const clearFilterButton = cssClass(classPrefix, 'clear-filter', {
  position: 'absolute',
  top: 0,
  right: 0,
  $nest: {
    '&:not(:hover)': {
      backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, 'white')
    }
  }
});

export const searchInput = cssClass(classPrefix, 'search-input', {
  width: '100%',
});

export const filterWrapper = cssClass(classPrefix, 'filterWrapper', {
  ...filterComponentStyle,
  position: 'relative'
});

export const filterComponent = cssClass(classPrefix, 'filter', filterComponentStyle);

export const filterGroup = cssClass(classPrefix, 'filter-group', {
  border: 0,
  padding: 0,
  margin: 0,
  marginTop: TabStyles.Spacing.ExtraLargeSpace
});

export const filterGroupHeader = cssClass(classPrefix, 'group-header', {
  margin: 0,
  padding: 0,
  fontWeight: 'bold'
});

export const dropdownListContainer = cssClass(classPrefix, 'dropdown-list', {
  maxHeight: filteringListContainerHeight
});

export const dropdownListItemLeftAligned = cssClass(classPrefix, 'dropdown-list-item-left', {
  display: 'inline-block',
  textOverflow: 'ellipsis',
  maxWidth: 'calc(100% - 36px)',
  overflowX: 'hidden',
  verticalAlign: 'middle'
});

export const dropdownListItemRightAligned = cssClass(classPrefix, 'dropdown-list-item-right', {
  float: 'right',
  verticalAlign: 'middle'
});
